import { render, staticRenderFns } from "./SaleFeatureCard.vue?vue&type=template&id=5f30a146"
import script from "./SaleFeatureCard.vue?vue&type=script&lang=js"
export * from "./SaleFeatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports